import type {FC} from 'react';

// import type {ButtonProps} from '@/modules/foundation/components/button';
import {CallToAction} from '@/modules/foundation/components/call-to-action/CallToAction';
import {CallToActionGroup} from '@/modules/foundation/components/call-to-action-group/CallToActionGroup';

import {linkFragmentToHref} from '../../link/query';

import type {CallToActionLineFragment} from './query';

interface Props {
	value: CallToActionLineFragment;
	className?: string;
	theme?:
		| 'white'
		| 'dypgronnIndustri'
		| 'lysgronnIndustri'
		| 'oransjeIndustri'
		| 'blaIndustri'
		| 'gronnIndustri';
}

export const CallToActionLineContainer: FC<Props> = ({value, className, theme}) => {
	let intent: 'primary' | 'secondary' | null | undefined = undefined;

	switch (theme) {
		case 'dypgronnIndustri':
			intent = 'primary';
			break;
		case 'lysgronnIndustri':
			intent = 'primary';
			break;
		case 'oransjeIndustri':
			intent = 'secondary';
			break;
		case 'blaIndustri':
			intent = 'primary';
			break;
		case 'gronnIndustri':
			intent = 'secondary';
			break;
		default:
			intent = 'primary';
			break;
	}

	return (
		<CallToActionGroup className={className}>
			{value.callToActions?.map((cta) => (
				<CallToAction
					key={cta._key}
					text={cta.text ?? ''}
					targetBlank={cta.targetBlank}
					href={linkFragmentToHref({
						type: cta.type,
						href: cta.href,
						_type: 'link',
						reference: cta.reference,
						targetBlank: cta.targetBlank,
					})}
					intent={intent}
				/>
			))}
		</CallToActionGroup>
	);
};
